import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import { getAuth, onAuthStateChanged } from "firebase/auth"; // Firebase Auth
import "./CommunityFavourites.css"; // Main CSS for Community Favourites
import CommunityHeader from "../../components/Community/CommunityHeader"; // Header component
import CommunityProfileDescription from "../../components/Community/Communityprofiledescription"; // Profile Description component
import CommunityTabsRoom from "../../components/Community/Communitytabsroom"; // Tabs Component

const socket = io("http://localhost:5000");

const CommunityFavourites = () => {
  const [messages, setMessages] = useState([]);
  const [typing, setTyping] = useState("");
  const [messageInput, setMessageInput] = useState("");
  const [userName, setUserName] = useState("User"); // State for user's name
  const [userPhoto, setUserPhoto] = useState(null); // State for user's profile picture

  // Fetch user data from Firebase
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserName(user.displayName || "User"); // Fetch user's name
        setUserPhoto(user.photoURL || "https://via.placeholder.com/150"); // Fetch user's avatar
      } else {
        setUserName("User"); // Default if user logs out
        setUserPhoto("https://via.placeholder.com/150"); // Default avatar
      }
    });

    return () => unsubscribe(); // Cleanup on component unmount
  }, []);

  // Socket.IO
  useEffect(() => {
    socket.on("message", (msg) => {
      setMessages((prev) => [...prev, msg]);
    });

    socket.on("typing", (user) => {
      setTyping(`${user} is typing...`);
      setTimeout(() => setTyping(""), 3000);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const handleSendMessage = () => {
    if (messageInput.trim()) {
      socket.emit("send_message", { user: userName, text: messageInput });
      setMessages((prev) => [...prev, { user: userName, text: messageInput }]);
      setMessageInput("");
    }
  };

  return (
    <div className="CommunityFavourites-container">
      <div className="CommunityFavourites">
        {/* Top Section */}
        <CommunityHeader
          roomTitle={`${userName}'s Hosting`} // Dynamic room title
          roomName="ROOM NAME: FAVOURITES"
        />

        {/* Profile Details Section */}
        <CommunityProfileDescription
          userName={userName} // Dynamic user name
          description={`Welcome to the favourites section of ${userName}'s room. Explore and manage all your favourite content here.`}
          avatarSrc={userPhoto} // Dynamic avatar
        />

        {/* Tabs Section */}
        <CommunityTabsRoom />

        {/* Messages Section */}
        <div className="CommunityFavourites-chat">
          {messages.map((msg, index) => (
            <div key={index} className="CommunityFavourites-message">
              <p>
                <strong>{msg.user}: </strong>
                {msg.text}
              </p>
            </div>
          ))}
          <p className="CommunityFavourites-typing">{typing}</p>
          <div className="CommunityFavourites-input">
            <input
              type="text"
              value={messageInput}
              onChange={(e) => setMessageInput(e.target.value)}
              placeholder="Type your message"
            />
            <button onClick={handleSendMessage}>Send</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityFavourites;
